// extracted by mini-css-extract-plugin
export default {"heading":"contact_heading__9H7li","anchor":"contact_anchor__zid8l","contact":"contact_contact__vxFwx"};